import { useAuth } from "@workos-inc/authkit-react";
import { Navigate } from "react-router";
import { ReactNode } from "react"; 

interface RoleRestrictedRouteProps {
    children: ReactNode | ((role: string) => ReactNode);
    allowedRoles: string[];
  }
  
const RoleRestrictedRoute = ({ children, allowedRoles }: RoleRestrictedRouteProps) => {
  const { user, role } = useAuth();

  if (!user) {
    return <Navigate to="/auth" replace />;
  }

  if (!role) {
    return <Navigate to="/auth" replace />;
  }

  if (!allowedRoles.includes(role)) {
    return <Navigate to={role === "member" ? "/assistant" : "/documents"} replace />;
  }

  // Handle render prop pattern where children is a function
  return <>{typeof children === "function" ? children(role) : children}</>;
};

export default RoleRestrictedRoute;
